export default "__VITE_ASSET__e7b4386c__"